import { render } from "./ApiLoadingDisplay.vue?vue&type=template&id=52de7f37&ts=true"
import script from "./ApiLoadingDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApiLoadingDisplay.vue?vue&type=script&setup=true&lang=ts"

import "./ApiLoadingDisplay.vue?vue&type=style&index=0&id=52de7f37&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/common/api/ApiLoadingDisplay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52de7f37"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52de7f37', __exports__)) {
    api.reload('52de7f37', __exports__)
  }
  
  module.hot.accept("./ApiLoadingDisplay.vue?vue&type=template&id=52de7f37&ts=true", () => {
    api.rerender('52de7f37', render)
  })

}


export default __exports__